import { arrayOptional } from '../../util/joi';
import { schema as LiabilitySchema } from '../finance/Liability.schema';
import { schema as AssetSchema } from '../finance/Asset.schema';
import { schema as IncomeSchema } from '../finance/Income.schema';

export const schema = (Joi: any) =>
  Joi.object().keys({
    liabilities: arrayOptional(Joi, LiabilitySchema(Joi, 'Liabilities -')),
    assets: arrayOptional(Joi, AssetSchema(Joi, 'Assets -')),
    income: arrayOptional(Joi, IncomeSchema(Joi, 'Income -'))
  });

export default {
  schema
};
